// extracted by mini-css-extract-plugin
export var accordion = "_f7-0";
export var chevron = "_f7-3";
export var closed = "_f7-2";
export var content = "_f7-4";
export var open = "_f7-1";
export var rotate = "_f7-5";